import convertEnumToString from './convertEnumToString'

import { ContactType } from 'types/api.graphql'

type ProjectContact = {
  type: ContactType
  customType?: string
}

export const getProjectContactRole = (contact: ProjectContact) => {
  if (contact.type === ContactType.Other && contact.customType) {
    return contact.customType
  }

  return contact.type ? convertEnumToString(contact.type) : 'N/A'
}
